import React, { useState, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { makeStyles, Typography, Button, Divider } from "@material-ui/core";
import { vsprintf } from "sprintf-js";
import BrandLogoImage from "../common/BrandLogoImage";
import commons from "./../common/commons";

const hebrewLabels = {
  inStockImmediately: "במלאי מיידי",
  whyItsGoodForYou: "למה זה טוב עבורך?",
  buyNow: "קנה עכשיו",
  rating: "דירוג",
};

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    marginTop: "1.5rem",
    display: "grid",
    gridTemplateColumns: "16.5rem 1fr", //16.5
    backgroundColor: "#ffffff",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    padding: "1rem",
    borderRadius: "8px",
    gap: "0.5rem",
    maxWidth: "900px", // Prevent extreme stretching on very wide screens
    margin: "1.5rem auto 0", // Center the card on desktop
    "@media (max-width: 670px)": {
      gridTemplateColumns: "1fr",
      margin: "1.5rem 0 0", // Reset margin for mobile
    },
    "@media (max-width: 370px)": {
      padding: "0.4rem",
    },
  },
  imageContainer: {
    position: "relative",
    "@media (max-width: 670px)": {
      marginTop: "0.5rem",
      width: "100%",
      height: "12rem",
      overflow: "hidden",
    },
  },
  tirePhoto: {
    width: "100%",
    height: "auto",
    objectFit: "cover",
    borderRadius: "8px",
    maxWidth: "100%",
  },
  tireBrand: {
    position: "absolute",
    bottom: "0",
    left: "0",
    backgroundColor: "white",
    width: "9rem",
    height: "1.5rem",
    borderRadius: "4px",
  },
  contentRight: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  tireName: {
    fontSize: "22px",
    fontWeight: 525,
  },
  mobileTitle: {
    display: "block",
    [theme.breakpoints.up(670)]: {
      display: "none",
    },
  },
  desktopTitle: {
    display: "none",
    [theme.breakpoints.up(670)]: {
      display: "block",
    },
  },
  containerLabels: {
    display: "flex",
    flexDirection: "row",
    gap: "1rem",
    marginTop: "1rem",
    "@media (max-width: 670px)": {
      flexDirection: "column",
    },
  },
  labelSizes: {
    padding: "0.2rem 0.8rem",
    backgroundColor: "#e0e0e0",
    width: "fit-content",
    borderRadius: "12px",
  },
  labelAvailability: {
    padding: "0.2rem 0.8rem",
    backgroundColor: "#0c9b4b",
    color: "#ffffff",
    borderRadius: "12px",
    width: "fit-content",
    fontSize: "14px",
  },
  diveder: {
    display: "block",
    marginTop: "0.5rem",
    width: "100%",
    boxSizing: "border-box",
    [theme.breakpoints.up(670)]: {
      display: "none",
    },
  },
  containerDescription: {
    marginTop: "1rem",
    width: "100%",
    overflowWrap: "break-word",
    wordBreak: "break-word",
  },
  titleDescription: {
    fontSize: "16px",
    fontWeight: 525,
  },
  description: {
    fontSize: "14px",
    color: "#333",
    width: "100%",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  },
  containerRatingView: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "1rem",
    gap: "1rem",
    "@media (min-width: 671px)": {
      maxWidth: "320px", // Limit the rating/button container width on desktop
      margin: "1rem auto 0", // Center the container
    },
  },
  rating: {
    fontWeight: 600,
    fontSize: "20px",
    textAlign: "center",
    width: "100%",
    "@media (max-width: 370px)": {
      fontSize: "18px",
    },
  },
  labelRating: {
    padding: "0.4rem 1rem",
    backgroundColor: "#f4b342",
    borderRadius: "12px",
    fontSize: "18px",
    fontWeight: "bold",
    "@media (max-width: 370px)": {
      fontSize: "16px",
      padding: "0.3rem 0.8rem",
    },
  },
  priceContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: "1rem 0",
    padding: "1rem",
    backgroundColor: "#f8f8f8",
    borderRadius: "8px",
    border: "2px solid #ff7900",
    "@media (min-width: 671px)": {
      maxWidth: "280px", // Limit width on desktop for better proportion
      margin: "1rem auto", // Center the price container
    },
  },
  price: {
    fontSize: "26px",
    fontWeight: "bold",
    color: "#ff7900",
    lineHeight: "1.2",
  },
  priceLabel: {
    fontSize: "14px",
    color: "#666",
    marginTop: "4px",
  },
  buttonView: {
    width: "90%",
    height: "3rem",
    backgroundColor: "#FF7500",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "bold",
    borderRadius: "8px",
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: "#e06600",
    },
    "@media (min-width: 671px)": {
      maxWidth: "280px", // Limit button width on desktop
      width: "100%", // Take full width up to max-width
    },
    "@media (max-width: 370px)": {
      height: "2.5rem",
      fontSize: "14px",
    },
  },
}));

export default function SuggestedTireCard({ tireInfo, onTireClick }) {
  const classes = useStyles();
  const history = useHistory();

  const handleBuyNowClick = (event) => {
    event.preventDefault();

    // Call the onTireClick callback if provided
    if (onTireClick) {
      onTireClick(tireInfo);
    }

    // Navigate to the tire page
    setTimeout(() => {
      history.push(`/tire/moto/${tireInfo.ean}/${tireInfo.name}`);
    }, 100);
  };

  const { url: primaryPhoto } = commons.getProductPrimaryImage(
    tireInfo.photos,
    tireInfo.ean
  );

  return (
    <div className={classes.cardRoot}>
      {/*Mobile title*/}
      <Typography className={`${classes.tireName} ${classes.mobileTitle}`}>
        {tireInfo.displayName}
      </Typography>

      <div className={classes.imageContainer}>
        <img className={classes.tirePhoto} src={primaryPhoto} alt="Tire" />

        <BrandLogoImage
          brand={tireInfo.brand}
          className={classes.tireBrand}
          alt={`${tireInfo.brand} Brand`}
        />
      </div>

      <div className={classes.contentRight}>
        <div style={{ flex: 1 }}>
          {/* DESKTOP title */}
          <Typography className={`${classes.tireName} ${classes.desktopTitle}`}>
            {tireInfo.displayName}
          </Typography>

          <div className={classes.containerLabels}>
            <Typography className={classes.labelSizes}>
              {tireInfo.displaySize}
            </Typography>
            <Typography className={classes.labelAvailability}>
              {tireInfo.visibility == "instock"
                ? hebrewLabels.inStockImmediately
                : ""}
            </Typography>
          </div>
          <Divider className={classes.diveder} />

          {tireInfo.price && (
            <div className={classes.priceContainer}>
              <Typography className={classes.price}>
                {vsprintf("%.2f", [tireInfo.price])} ₪
              </Typography>
              <Typography className={classes.priceLabel}>
                המחיר כולל מע״מ
              </Typography>
            </div>
          )}

          <div className={classes.containerDescription}>
            <Typography className={classes.titleDescription}>
              {hebrewLabels.whyItsGoodForYou}
            </Typography>
            <Typography className={classes.description}>
              {tireInfo.reason}
            </Typography>
          </div>
        </div>

        <div className={classes.containerRatingView}>
          <Typography className={classes.rating}>
            {hebrewLabels.rating}:{" "}
            <span className={classes.labelRating}>{tireInfo.score}/10</span>
          </Typography>
          <Button
            variant="contained"
            className={classes.buttonView}
            onClick={handleBuyNowClick}
          >
            {hebrewLabels.buyNow}
          </Button>
        </div>
      </div>
    </div>
  );
}
